export * from "./employment-contract-down";
import { EMPLOYMENT_FIELD_SIDES, EMPLOYMENT_FIELD_TYPES } from "./const";

/**
 * @typedef {object} EmploymentForm
 *
 * @property {string} _id
 *
 * @property {string} _file
 * @property {File|object} [file]
 *
 * @property {string[]} _pages
 * @property {Array<File|object>} pages
 *
 * @property {string} name
 * @property {EmploymentField[]} fields
 *
 * @property {string} createdAt
 * @property {string} updatedAt
 */

/**
 * @param {EmploymentForm} data
 * @returns {EmploymentForm}
 */
export function initEmploymentForm(data = {}) {
    data = {
        ...(data || {}),

        _id: data?._id,

        _file: data?._file || null,
        file: data?.file || null,

        _pages: [...(data?._pages || [])],
        pages: [...(data?.pages || [])],

        name: data?.name || data?.file?.name || null,
        fields: [...(data?.fields || [])].map(initEmploymentField),

        createdAt: data?.createdAt,
        updatedAt: data?.updatedAt,
    };

    if (!data._id) delete data._id;

    if (!data.file) delete data.file;

    if (!data.createdAt) delete data.createdAt;
    if (!data.updatedAt) delete data.updatedAt;

    return data;
}

/**
 * @typedef {object} EmploymentContract
 *
 * @property {string} _id
 *
 * @property {string} _form
 * @property {EmploymentForm} [form]
 *
 * @property {string} _user
 * @property {object} [user]
 *
 * @property {string} subject
 * @property {boolean} isSigned
 * @property {EmploymentField[]} fields_document
 * @property {EmploymentField[]} fields_employee
 *
 * @property {string} [createdAt]
 * @property {string} [updatedAt]
 * @property {string} [signedAt]
 */

/**
 * @param {EmploymentContract} data
 * @returns {EmploymentContract}
 */
export function initEmploymentContract(data = {}) {
    data = {
        ...(data || {}),

        _id: data?._id,

        _form: data?._form || null,
        form: data?.form,

        _user: data?._user || null,
        user: data?.user,

        subject: data?.subject || null,
        isSigned: data?.isSigned ?? false,

        fields_document: [...(data?.fields_document || [])].map(initEmploymentField),
        fields_employee: [...(data?.fields_employee || [])].map(initEmploymentField),

        createdAt: data?.createdAt,
        updatedAt: data?.updatedAt,
        signedAt: data?.signedAt,
    };

    if (!data._id) delete data._id;

    if (!data.form) delete data.form;
    
    if (!data.user) delete data.user;

    if (!data.createdAt) delete data.createdAt;
    if (!data.updatedAt) delete data.updatedAt;
    if (!data.signedAt) delete data.signedAt;

    return data;
}

/**
 * @typedef {object} EmploymentField
 *
 * @property {string} _img
 * @property {null|File|object} img
 *
 * @property {string} _file
 * @property {null|File|object} file
 *
 * @property {keyof EMPLOYMENT_FIELD_SIDES} side
 * @property {keyof EMPLOYMENT_FIELD_TYPES} type
 *
 * @property {string} term
 * @property {string|boolean} data
 *
 * @property {number} page
 *
 * @property {object} axis
 * @property {number} axis.x
 * @property {number} axis.y
 *
 * @property {object} size
 * @property {number} size.w
 * @property {number} size.h
 *
 * @property {boolean} isRequired
 *
 * @property {string} [tempId]
 */

/**
 * @param {EmploymentField} data
 * @returns {EmploymentField}
 */
export function initEmploymentField(data = {}) {
    return {
        ...(data || {}),

        _img: data?._img || null,
        img: data?.img || null,

        _file: data?._file || null,
        file: data?.file || null,

        side: data?.side || EMPLOYMENT_FIELD_SIDES.DOCUMENT.value,
        type: data?.type || EMPLOYMENT_FIELD_TYPES.TEXT.value,

        term: data?.term || null,
        data: data?.data || null,

        page: data?.page ?? 0,

        axis: {
            ...(data?.axis || {}),
            x: data?.axis?.x || 0,
            y: data?.axis?.y || 0,
        },

        size: {
            ...(data?.size || {}),
            w: data?.size?.w || 0,
            h: data?.size?.h || 0,
        },

        isRequired: data?.isRequired || false,

        tempId: data?.tempId ?? `${Math.random()}`.slice(2),
    };
}
